import React from 'react'
import { Translation, useTranslation } from 'react-i18next'
import { I18nInternalContext } from './internal/I18nInternalContext'
import hoistNonReactStatics from 'hoist-non-react-statics' // 已作为间接依赖引入，减少对原工程修改，不单独声明依赖
/**
 * 同时，解决业务手动调用 t() 的问题，从命令式代码变为声明式
 */
export function withT() {
  return function wrap(Component) {
    class WithTranslation extends React.PureComponent {
      static displayName = `alExWithTranslation(${
        Component.displayName || Component.name || 'Component'
      })`
      static contextType = I18nInternalContext
      // eslint-disable-next-line
      constructor(props) {
        super(props)
      }
      render() {
        return (
          <Translation ns={this.context ? this.context.namespace : undefined}>
            {(t) => <Component {...this.props} t={t} />}
          </Translation>
        )
      }
    }
    hoistNonReactStatics(WithTranslation, Component)
    return WithTranslation
  }
}

export function useT(namespace) {
  const i18nCtx = React.useContext(I18nInternalContext)
  // 已将语言包设置为前置依赖，不需要考虑语言包异步加载的问题（无异步加载的中间态）
  // export 时由于语言未确定，实际返回的 ''。业务场景可不关注此行为，见 FormattedMessage#renderContent
  // 未提供 namespace 时，使用最近的一个上下文中指定的 namespace
  const { t } = useTranslation(namespace || i18nCtx.namespace)
  // 注意与 FormattedMessage 行为不同，加载时返回 ''，而非 '&emsp;&emsp;' 或 ' '
  return t
}
